import React, { useEffect } from "react";
import {
  Box,
  Button,
  Checkbox,
  ClickAwayListener,
  Divider,
  FormControl,
  FormControlLabel,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography,
  Autocomplete,
  Chip,
} from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { useParams } from "react-router-dom";
import axios from "axios";
import { useSelector } from "react-redux";
import Cookies from "js-cookie";
import ViewCandidateBy from "./viewCandidateBy";

const AdvanceFilter = (props) => {
  const { id } = useParams();

  const isJobezeAdminSelected = props.selectedOptions?.some(
    (option) => option.name === "Jobeze Admin",
  );

  useEffect(() => {
    if (isJobezeAdminSelected && props.isBulkUpload === 1) {
      props.handleBulkUploadChange({ target: { value: "" } });
    }
  }, [isJobezeAdminSelected]);

  useEffect(() => {
    const fetchData = async () => {
      if (!id) return;
      try {
        const response = await axios.post(
          `question-list-job/${id}`,
          { applyFilter: 1 },
          {
            headers: {
              authorization:
                Cookies.get("_secure_ARJ_") || Cookies.get("_secure_ref"),
            },
          },
        );
        const questions = response.data.message;
        props.setQuestion(questions);
        const a = questions.map((question) => ({
          type_id: question.question_type,
          question_id: question.question_id,
          ans_text: "",
          errorText: null,
          operator: "=",
          isChecked: false,
        }));
        props.setCurrent(a);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  if (!props.advanceFilter) return null;

  // Width: Jobs page narrow (300), Manage Candidates wider (340)
  const panelWidth = props.viewCandidateFlag === 1 ? 340 : 300;

  return (
    <ClickAwayListener onClickAway={props.handleAdvanceFilterClose}>
      <Paper
        elevation={4}
        sx={{
          position: "absolute",
          top: "calc(100% + 6px)",
          right: 0,
          width: panelWidth,
          borderRadius: "10px",
          border: "1px solid #e5e7eb",
          zIndex: 1300,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        {/* ── Header ── */}
        <Box
          sx={{
            px: 2,
            py: 1.2,
            borderBottom: "1px solid #f1f5f9",
            background: "#f8fafc",
          }}
        >
          <Typography
            sx={{ fontSize: "13px", fontWeight: 600, color: "#1a2e4a" }}
          >
            {props.viewCandidateFlag === 1
              ? "Candidate Filters"
              : "Jobs Filters"}
          </Typography>
        </Box>

        {/* ── Body ── */}
        <Box sx={{ px: 2, py: 1.5, overflowY: "auto", maxHeight: 420 }}>
          {/* Created By */}
          <Box sx={{ mb: props.viewCandidateFlag === 1 ? 2 : 0 }}>
            <Typography
              sx={{
                fontSize: "12px",
                fontWeight: 600,
                color: "#6b7280",
                mb: 0.8,
                textTransform: "uppercase",
                letterSpacing: "0.4px",
              }}
            >
              Created By
            </Typography>
            <Autocomplete
              multiple
              disableCloseOnSelect
              limitTags={1}
              getLimitTagsText={(more) => `+${more}`}
              options={props.candidateList || []}
              value={props.selectedOptions || []}
              onChange={props.handleSelectionData}
              getOptionLabel={(option) => option.name || ""}
              isOptionEqualToValue={(option, value) =>
                option.name === value.name
              }
              renderOption={(renderProps, option, { selected }) => (
                <li {...renderProps} style={{ padding: "4px 8px" }}>
                  <Checkbox
                    icon={<CheckBoxOutlineBlankIcon sx={{ fontSize: 16 }} />}
                    checkedIcon={<CheckBoxIcon sx={{ fontSize: 16 }} />}
                    checked={selected}
                    sx={{
                      p: 0.4,
                      mr: 0.8,
                      color: "#9ca3af",
                      "&.Mui-checked": { color: "#3b82f6" },
                    }}
                  />
                  <Typography sx={{ fontSize: "13px", color: "#374151" }}>
                    {option.name}
                  </Typography>
                </li>
              )}
              renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                  <Chip
                    key={index}
                    label={option.name}
                    size="small"
                    {...getTagProps({ index })}
                    sx={{
                      fontSize: "11px",
                      height: "20px",
                      background: "#eff6ff",
                      color: "#3b82f6",
                    }}
                  />
                ))
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder={
                    (props.selectedOptions || []).length === 0
                      ? "Search users..."
                      : ""
                  }
                  size="small"
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                      fontSize: "13px",
                      minHeight: "35px",
                      overflowY: "auto",
                      "& fieldset": { borderColor: "#e5e7eb" },
                      "&:hover fieldset": { borderColor: "#d1d5db" },
                    },
                  }}
                />
              )}
              ListboxProps={{ sx: { maxHeight: 180, fontSize: "13px" } }}
            />
          </Box>

          {/* View Candidates By — only Manage Candidates */}
          {props.viewCandidateFlag === 1 && (
            <>
              <Divider sx={{ my: 1.5 }} />
              <Box sx={{ mb: 1 }}>
                <Typography
                  sx={{
                    fontSize: "12px",
                    fontWeight: 600,
                    color: "#6b7280",
                    mb: 0.8,
                    textTransform: "uppercase",
                    letterSpacing: "0.4px",
                  }}
                >
                  View Candidates By
                </Typography>
                <ViewCandidateBy
                  handleViewCandidateBy={props.handleViewCandidateBy}
                  selectedViewName={props.selectedViewName}
                  radioNames={props?.radioNames}
                />
              </Box>
              <FormControl sx={{ mt: 0.5 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      size="small"
                      checked={props.isBulkUpload === 1}
                      onChange={props.handleBulkUploadChange}
                      disabled={isJobezeAdminSelected}
                      sx={{ "&.Mui-checked": { color: "#3b82f6" } }}
                    />
                  }
                  label={
                    <Typography sx={{ fontSize: "13px", color: "#374151" }}>
                      Bulk Upload
                    </Typography>
                  }
                />
              </FormControl>
            </>
          )}

          {/* Additional Questions */}
          {props.question?.length > 0 && (
            <>
              <Divider sx={{ my: 1.5 }} />
              <Typography
                sx={{
                  fontSize: "12px",
                  fontWeight: 600,
                  color: "#6b7280",
                  mb: 1.5,
                  textTransform: "uppercase",
                  letterSpacing: "0.4px",
                }}
              >
                Additional Questions
              </Typography>
              {props.question.map((question, index) => (
                <Box key={question.question_id} sx={{ mb: 2 }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        size="small"
                        checked={
                          props.checkboxValues[question.question_id] || false
                        }
                        onChange={(e) =>
                          props.handleCheckboxChange(
                            e,
                            question.question_id,
                            index,
                          )
                        }
                        sx={{ "&.Mui-checked": { color: "#3b82f6" } }}
                      />
                    }
                    label={
                      <Typography sx={{ fontSize: "13px", color: "#374151" }}>
                        {question.question.charAt(0).toUpperCase() +
                          question.question.slice(1)}
                      </Typography>
                    }
                  />
                  {question.question_type === 2 && (
                    <Box sx={{ display: "flex", gap: 1, mt: 0.5, pl: 3.5 }}>
                      <FormControl>
                        <Select
                          size="small"
                          sx={{ width: "58px", fontSize: "13px" }}
                          defaultValue="="
                          value={
                            props.operatorValues[question.question_id] || "="
                          }
                          disabled={!props.checkboxValues[question.question_id]}
                          onChange={(e) =>
                            props.handleOperatorValuesChange(
                              e,
                              question.question_id,
                              index,
                            )
                          }
                        >
                          <MenuItem value="=">{"="}</MenuItem>
                          <MenuItem value="<">{"<"}</MenuItem>
                          <MenuItem value=">">{">"}</MenuItem>
                          <MenuItem value="<=">{"≤"}</MenuItem>
                          <MenuItem value=">=">{"≥"}</MenuItem>
                        </Select>
                      </FormControl>
                      <TextField
                        size="small"
                        placeholder="Enter numeric value"
                        type="tel"
                        autoComplete="off"
                        disabled={!props.checkboxValues[question.question_id]}
                        value={props.textFields[question.question_id] || ""}
                        InputProps={{
                          inputProps: {
                            maxLength: 13,
                            onKeyPress: (e) => {
                              const c = e.which || e.keyCode;
                              if (c > 31 && (c < 48 || c > 57))
                                e.preventDefault();
                            },
                            pattern: "[0-9]*",
                          },
                        }}
                        onPaste={(e) => {
                          e.preventDefault();
                          const filtered = e.clipboardData
                            .getData("text/plain")
                            .replace(/[^\d]/g, "");
                          navigator.clipboard.writeText(filtered).then(() => {
                            e.target.value = filtered;
                            props.handleTextFieldChange(
                              e,
                              question.question_id,
                              index,
                            );
                          });
                        }}
                        onChange={(e) =>
                          props.handleTextFieldChange(
                            e,
                            question.question_id,
                            index,
                          )
                        }
                        error={!!props.quesAnsArrayFilter[index]?.errorText}
                        helperText={props.quesAnsArrayFilter[index]?.errorText}
                        sx={{
                          flex: 1,
                          "& .MuiOutlinedInput-root": {
                            fontSize: "13px",
                            borderRadius: "8px",
                          },
                        }}
                      />
                    </Box>
                  )}
                  {question.question_type === 3 && (
                    <Box sx={{ pl: 3.5, mt: 0.5 }}>
                      <FormControl>
                        <RadioGroup
                          row
                          value={props.radioValues[question.question_id] || ""}
                          onChange={(e) =>
                            props.handleRadioChange(
                              e,
                              question.question_id,
                              index,
                            )
                          }
                        >
                          <FormControlLabel
                            value="yes"
                            disabled={
                              !props.checkboxValues[question.question_id]
                            }
                            control={
                              <Radio
                                size="small"
                                sx={{ "&.Mui-checked": { color: "#3b82f6" } }}
                              />
                            }
                            label={
                              <Typography sx={{ fontSize: "13px" }}>
                                Yes
                              </Typography>
                            }
                          />
                          <FormControlLabel
                            value="no"
                            disabled={
                              !props.checkboxValues[question.question_id]
                            }
                            control={
                              <Radio
                                size="small"
                                sx={{ "&.Mui-checked": { color: "#3b82f6" } }}
                              />
                            }
                            label={
                              <Typography sx={{ fontSize: "13px" }}>
                                No
                              </Typography>
                            }
                          />
                        </RadioGroup>
                        {props.quesAnsArrayFilter[index]?.errorText && (
                          <Typography
                            variant="caption"
                            sx={{ color: "#d32f2f" }}
                          >
                            {props.quesAnsArrayFilter[index]?.errorText}
                          </Typography>
                        )}
                      </FormControl>
                    </Box>
                  )}
                </Box>
              ))}
            </>
          )}
        </Box>

        {/* ── Footer ── */}
        <Box
          sx={{
            px: 2,
            py: 1.2,
            borderTop: "1px solid #f1f5f9",
            background: "#fafafa",
            display: "flex",
            justifyContent: "flex-end",
            gap: 1,
          }}
        >
          <Button
            size="small"
            onClick={props.handleFilterReset}
            sx={{
              fontSize: "13px",
              fontWeight: 600,
              color: "#6b7280",
              textTransform: "uppercase",
              letterSpacing: "0.4px",
              "&:hover": { background: "#f3f4f6" },
            }}
          >
            Reset
          </Button>
          <Button
            size="small"
            variant="contained"
            onClick={props.handleAdvanceFilterApply}
            disabled={
              props.viewCandidateFlag === 1
                ? false
                : !Object.values(props.radioValues || {}).some((v) => v) &&
                  !Object.values(props.textFields || {}).some((v) => v) &&
                  (props.selectedOptions || []).length === 0
            }
            sx={{
              fontSize: "13px",
              fontWeight: 600,
              textTransform: "uppercase",
              letterSpacing: "0.4px",
              background: "#3b82f6",
              borderRadius: "6px",
              px: 2.5,
              "&:hover": { background: "#2563eb" },
              "&.Mui-disabled": { background: "#bfdbfe", color: "#fff" },
            }}
          >
            Apply
          </Button>
        </Box>
      </Paper>
    </ClickAwayListener>
  );
};

export default AdvanceFilter;
